import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var IBrandOrder;
(function (IBrandOrder) {
  var State;
  (function (State) {
    /**
     * The brand order was created and is waiting to be fulfilled.
     */
    State["NEW"] = "NEW";
    /**
     * The brand has been cancel (all order items were canceled).
     */
    State["CANCELED"] = "CANCELED";
    /**
     * The brand has been contacted about this brand order but hasn't accepted it yet.
     */
    State["BRAND_CONTACTED"] = "BRAND_CONTACTED";
    /**
     * The brand order is pending a review of the retailer.
     */
    State["WAITING_ON_REVIEW"] = "WAITING_ON_REVIEW";
    /**
     * The brand marked some items as backordered or discontinued. We are waiting for the
     * Retailer to select how they want to proceed.
     */
    State["PENDING_RETAILER_CONFIRMATION"] = "PENDING_RETAILER_CONFIRMATION";
    /**
     * The brand has accepted this brand order and is processing it but hasn't shipped it yet.
     */
    State["PROCESSING"] = "PROCESSING";
    /**
     * This brand order has been shipped.
     */
    State["SHIPPED"] = "SHIPPED";
    /**
     * This brand order has been delivered.
     */
    State["DELIVERED"] = "DELIVERED";
    /**
     * All the items in this brand order are backordered.
     */
    State["BACKORDERED"] = "BACKORDERED";
    /**
     * The brand order has a shipping cost adjustment request pending action by the retailer.
     */
    State["PENDING_RETAILER_SHIPPING_COST_ADJUSTMENT_CONFIRMATION"] = "PENDING_RETAILER_SHIPPING_COST_ADJUSTMENT_CONFIRMATION";
    /**
     * The brand order is pending completed payment of overdue invoices by the retailer
     */
    State["WAITING_ON_RELEASE"] = "WAITING_ON_RELEASE";
  })(State = IBrandOrder.State || (IBrandOrder.State = {}));
  /**
   * This records "exceptions" on a brand order.
   * Exceptions may or may not cause a brand order to fail but we still want to track them.
   */
  var ExceptionReason;
  (function (ExceptionReason) {
    /**
     * Some of the items in this order are backordered.
     */
    ExceptionReason["BACKORDERED_ITEMS"] = "BACKORDERED_ITEMS";
    /**
     * TODO: This had a typo. Delete after migrating. Use DISCONTINUED_ITEMS.
     * @deprecated
     */
    ExceptionReason["DISCOUNTINUED_ITEMS"] = "DISCOUNTINUED_ITEMS";
    /**
     * Brand introduced a delay in fulfilling this order causing us to reach back to retailer.
     */
    ExceptionReason["DELAY"] = "DELAY";
    /**
     * This brand order had items whose data was incorrect (e.g., incorrect case size).
     */
    ExceptionReason["INCORRECT_ITEM_DATA"] = "INCORRECT_ITEM_DATA";
    /**
     * The brand had other exclusive relationships in the area of the retailer.
     */
    ExceptionReason["REJECTED_FOR_EXCLUSIVITY"] = "REJECTED_FOR_EXCLUSIVITY";
    /**
     * The brand didn't like the retailer.
     */
    ExceptionReason["REJECTED_RETAILER_NO_MATCH"] = "REJECTED_RETAILER_NO_MATCH";
    /**
     * The brand made a mistake and sent an incorrect amount and/or incorrect items.
     * This wasn't our fault but theirs.
     */
    ExceptionReason["INCORRECT_ITEMS_SHIPPED"] = "INCORRECT_ITEMS_SHIPPED";
    /**
     * Some or all of the items arrived damaged.
     */
    ExceptionReason["DAMAGED_ITEMS"] = "DAMAGED_ITEMS";
    /**
     * The retailer was deemed risky by us.
     */
    ExceptionReason["REJECTED_BY_INDIGO_FAIR"] = "REJECTED_BY_INDIGO_FAIR";
    /**
     * This order contained items that were discontinued.
     */
    ExceptionReason["DISCONTINUED_ITEMS"] = "DISCONTINUED_ITEMS";
    /**
     * The retailer claims they never received the package.
     */
    ExceptionReason["PACKAGE_NEVER_RECEIVED"] = "PACKAGE_NEVER_RECEIVED";
    /**
     * There was a Faire-caused shipping error on this brand order. This order should be considered perfect.
     */
    ExceptionReason["FAIRE_CAUSED_SHIPPING_ERROR"] = "FAIRE_CAUSED_SHIPPING_ERROR";
    /**
     * Used when manually overriding a specific brand order as perfect for the Top Shop program. The 'adminNote' field
     * should be used to capture the context of this override.
     */
    ExceptionReason["ADMIN_ADDED_IMPERFECT_ORDER_OVERRIDE"] = "ADMIN_ADDED_IMPERFECT_ORDER_OVERRIDE";
  })(ExceptionReason = IBrandOrder.ExceptionReason || (IBrandOrder.ExceptionReason = {}));
  /**
   * The reason why this brand order was created.
   */
  var CreationReason;
  (function (CreationReason) {
    CreationReason["NEW_ORDER"] = "NEW_ORDER";
    CreationReason["BACKORDER"] = "BACKORDER";
    CreationReason["REPLACE_DAMAGED_OR_MISSING_ITEMS"] = "REPLACE_DAMAGED_OR_MISSING_ITEMS";
    CreationReason["SPLIT_ORDER"] = "SPLIT_ORDER";
    CreationReason["ADMIN_CREATE_FAKE_REPLACEMENT_ORDER"] = "ADMIN_CREATE_FAKE_REPLACEMENT_ORDER";
  })(CreationReason = IBrandOrder.CreationReason || (IBrandOrder.CreationReason = {}));
  /**
   * The reason why this brand order was canceled.
   */
  var CancelReason;
  (function (CancelReason) {
    /**
     * Brand Reasons
     * Ensure that DbBrandOrder.BRAND_CANCEL_REASONS is kept in sync
     */
    CancelReason["REQUESTED_BY_RETAILER"] = "REQUESTED_BY_RETAILER";
    CancelReason["RETAILER_NOT_GOOD_FIT"] = "RETAILER_NOT_GOOD_FIT";
    CancelReason["ALL_ITEMS_CANCELED"] = "ALL_ITEMS_CANCELED";
    CancelReason["BRAND_INITIATED_OTHER"] = "BRAND_INITIATED_OTHER";
    CancelReason["SHOPIFY_OTHER"] = "SHOPIFY_OTHER";
    CancelReason["ITEM_OUT_OF_STOCK"] = "ITEM_OUT_OF_STOCK";
    CancelReason["INCORRECT_PRICING"] = "INCORRECT_PRICING";
    CancelReason["ORDER_TOO_SMALL"] = "ORDER_TOO_SMALL";
    /**
     * @deprecated
     */
    CancelReason["SHIPPING_COST_TOO_HIGH"] = "SHIPPING_COST_TOO_HIGH";
    CancelReason["INSIDER_FREE_SHIPPING_PARTNERSHIP_PROGRAM_BCFS"] = "INSIDER_FREE_SHIPPING_PARTNERSHIP_PROGRAM_BCFS";
    CancelReason["OTHER_NEARBY_CUSTOMER"] = "OTHER_NEARBY_CUSTOMER";
    /**
     * Retailer Reasons
     * Ensure that DbBrandOrder.RETAILER_CANCEL_REASONS is kept in sync
     */
    CancelReason["PLACED_BY_MISTAKE"] = "PLACED_BY_MISTAKE";
    CancelReason["CHANGE_REPLACE_ORDER"] = "CHANGE_REPLACE_ORDER";
    CancelReason["LEAD_TIME_TOO_LONG"] = "LEAD_TIME_TOO_LONG";
    CancelReason["PRODUCT_QUALITY_CONCERNS"] = "PRODUCT_QUALITY_CONCERNS";
    CancelReason["ALTERNATIVES_ON_FAIRE"] = "ALTERNATIVES_ON_FAIRE";
    CancelReason["CHEAPER_ELSEWHERE"] = "CHEAPER_ELSEWHERE";
    CancelReason["NO_LONGER_NEEDED"] = "NO_LONGER_NEEDED";
    CancelReason["ORDER_EDITED"] = "ORDER_EDITED";
    /**
     * When picking other, it is expected that a note is also passed.
     */
    CancelReason["OTHER"] = "OTHER";
    CancelReason["STUCK_WAITING_ON_REVIEW"] = "STUCK_WAITING_ON_REVIEW";
    CancelReason["BRAND_INVOICE_PAYMENT_FAILED"] = "BRAND_INVOICE_PAYMENT_FAILED";
    CancelReason["BRAND_INVOICE_DELETED"] = "BRAND_INVOICE_DELETED";
    CancelReason["REJECT_INTERNATIONAL_ORDER"] = "REJECT_INTERNATIONAL_ORDER";
    CancelReason["HOLD_PAYMENT_FAILED"] = "HOLD_PAYMENT_FAILED";
    CancelReason["STUCK_PROCESSING"] = "STUCK_PROCESSING";
    CancelReason["STUCK_BRAND_CONTACTED"] = "STUCK_BRAND_CONTACTED";
    /**
     * Canceled due to being stuck in PENDING_RETAILER_CONFIRMATION for 6 months or longer
     */
    CancelReason["STUCK_PENDING_RETAILER_CONFIRMATION"] = "STUCK_PENDING_RETAILER_CONFIRMATION";
    CancelReason["STUCK_BACKORDERED"] = "STUCK_BACKORDERED";
    CancelReason["FORBIDDEN_ONLINE_ONLY"] = "FORBIDDEN_ONLINE_ONLY";
    CancelReason["FORBIDDEN_SOCIAL_SELLER"] = "FORBIDDEN_SOCIAL_SELLER";
    /**
     * All brand orders were rejected when the retailer was rejected
     */
    CancelReason["RETAILER_REJECTED_BY_ADMIN"] = "RETAILER_REJECTED_BY_ADMIN";
    CancelReason["BRAND_BLACKLISTED"] = "BRAND_BLACKLISTED";
    /**
     * If any other reasons used by the warehouse are added,
     * they should also be added to InventoryManger.WAREHOUSE_CANCELLATION_REASONS
     */
    CancelReason["WAREHOUSE_LOST"] = "WAREHOUSE_LOST";
    CancelReason["WAREHOUSE_DAMAGED"] = "WAREHOUSE_DAMAGED";
    CancelReason["WAREHOUSE_WRONG_QUANTITY"] = "WAREHOUSE_WRONG_QUANTITY";
    CancelReason["WAREHOUSE_FTC_VIOLATION"] = "WAREHOUSE_FTC_VIOLATION";
    CancelReason["ALL_ITEMS_BACKORDERED"] = "ALL_ITEMS_BACKORDERED";
    CancelReason["SHIPPING_COST_ADJUSTMENT_REJECTED"] = "SHIPPING_COST_ADJUSTMENT_REJECTED";
    CancelReason["STUCK_WAITING_ON_RELEASE"] = "STUCK_WAITING_ON_RELEASE";
    CancelReason["OVERDUE_INVOICE_PAYMENT_FAILED"] = "OVERDUE_INVOICE_PAYMENT_FAILED";
    /**
     * Automatically cancelled by DS-driven ETL
     */
    CancelReason["AUTO_CANCEL_BY_ETL"] = "AUTO_CANCEL_BY_ETL";
  })(CancelReason = IBrandOrder.CancelReason || (IBrandOrder.CancelReason = {}));
  var FeeStrategy;
  (function (FeeStrategy) {
    /**
     * calculate commission and payout fee on the pre discounted amount of a brand order
     * @deprecated
     */
    FeeStrategy["PRE_BRAND_FUNDED_DISCOUNT"] = "PRE_BRAND_FUNDED_DISCOUNT";
    /**
     * calculate commission and payout fee on the post discounted amount of a brand order
     */
    FeeStrategy["POST_BRAND_FUNDED_DISCOUNT"] = "POST_BRAND_FUNDED_DISCOUNT";
  })(FeeStrategy = IBrandOrder.FeeStrategy || (IBrandOrder.FeeStrategy = {}));
  var ITag;
  (function (ITag) {
    var Type;
    (function (Type) {
      /**
       * The order was attributed to a Direct Marketing campaign the brand sent.
       * @deprecated
       */
      Type["DIRECT_MARKETING_CAMPAIGN"] = "DIRECT_MARKETING_CAMPAIGN";
      /**
       * The order was attributed to something else (e.g. a sales rep the brand is working with).
       */
      Type["ATTRIBUTION"] = "ATTRIBUTION";
      /**
       * The order was attributed to a Faire Affiliate.
       */
      Type["AFFILIATE_SOURCED"] = "AFFILIATE_SOURCED";
      /**
       * The order was placed while the user was in an Affiliate Linked Session AND at least ONE of the
       * items is from that Affiliate's Boards. Since Boards are editable it's important to tag here.
       */
      Type["AFFILIATE_COLLECTION_PURCHASE"] = "AFFILIATE_COLLECTION_PURCHASE";
      /**
       * A payment of this order has been attempted and has failed after the due date.
       */
      Type["HAS_FAILED_OVERDUE_PAYMENT"] = "HAS_FAILED_OVERDUE_PAYMENT";
      /**
       * This brand order skipped the verification process because of a Faire Direct relationship
       */
      Type["PASSED_THROUGH_VERIFICATION_DUE_TO_RELATIONSHIP"] = "PASSED_THROUGH_VERIFICATION_DUE_TO_RELATIONSHIP";
      /**
       * When this order was cancelled, it originated from an unverified Faire Direct Retailer
       */
      Type["CANCELLED_BRAND_ORDER_ORIGINATED_FROM_UNVERIFIED_FAIRE_DIRECT_RETAILER"] = "CANCELLED_BRAND_ORDER_ORIGINATED_FROM_UNVERIFIED_FAIRE_DIRECT_RETAILER";
      /**
       * One of the payments was disputed
       */
      Type["DISPUTED"] = "DISPUTED";
      /**
       * The order was attributed to a sample the brand sent to the same retailer prior to the order being placed.
       */
      Type["SAMPLE_REQUEST"] = "SAMPLE_REQUEST";
      /**
       * The order has had its due date extended by Admin
       */
      Type["HAD_DUE_DATE_MANUALLY_EXTENDED"] = "HAD_DUE_DATE_MANUALLY_EXTENDED";
      /**
       * The order was attributed to a marketing campaign the brand sent when the recipient opens the email.
       */
      Type["MARKETING_CAMPAIGN_OPENED"] = "MARKETING_CAMPAIGN_OPENED";
      /**
       * The order was attributed to a marketing campaign the brand sent when the recipient clicks the email.
       */
      Type["MARKETING_CAMPAIGN_CLICKED"] = "MARKETING_CAMPAIGN_CLICKED";
      /**
       * The brand order has a billing invoice associated with it
       */
      Type["HAS_BILLING_INVOICE"] = "HAS_BILLING_INVOICE";
    })(Type = ITag.Type || (ITag.Type = {}));
    /**
     * Return an instance of ITag with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ITag.build = function (partial) {
      return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
    };
  })(ITag = IBrandOrder.ITag || (IBrandOrder.ITag = {}));
  var IConversionRate;
  (function (IConversionRate) {
    /**
     * Describes the event related to this brand order when the rate was captured.
     */
    var Event;
    (function (Event) {
      /**
       * brand currency to retailer currency
       */
      Event["CREATED"] = "CREATED";
      Event["SHIPPED"] = "SHIPPED";
      Event["PAID"] = "PAID";
      /**
       * TODO(ryan.orr): Clean up currency conversion models
       *  We needed to make a separate event for brands to prevent breaking DS dashboards.
       */
      Event["CREATED_FOR_BRAND"] = "CREATED_FOR_BRAND";
      /**
       * brand currency to USD for finance and data science.
       */
      Event["CREATED_BRAND_TO_FAIRE"] = "CREATED_BRAND_TO_FAIRE";
      /**
       * retailer currency to USD for finance and data science.
       */
      Event["CREATED_RETAILER_TO_FAIRE"] = "CREATED_RETAILER_TO_FAIRE";
    })(Event = IConversionRate.Event || (IConversionRate.Event = {}));
    /**
     * Return an instance of IConversionRate with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IConversionRate.build = function (partial) {
      return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
    };
  })(IConversionRate = IBrandOrder.IConversionRate || (IBrandOrder.IConversionRate = {}));
  var FreeDutiesReason;
  (function (FreeDutiesReason) {
    FreeDutiesReason["FREE_DUTIES_REASON_UNKNOWN"] = "FREE_DUTIES_REASON_UNKNOWN";
    FreeDutiesReason["FREE_DUTIES_PROMO_2021"] = "FREE_DUTIES_PROMO_2021";
    FreeDutiesReason["EUROPEAN_BRAND_FREE_DUTIES_PROMO_2021"] = "EUROPEAN_BRAND_FREE_DUTIES_PROMO_2021";
    FreeDutiesReason["INSIDER_FREE_DUTIES"] = "INSIDER_FREE_DUTIES";
  })(FreeDutiesReason = IBrandOrder.FreeDutiesReason || (IBrandOrder.FreeDutiesReason = {}));
  var MarkAsDeliveredReason;
  (function (MarkAsDeliveredReason) {
    MarkAsDeliveredReason["MARK_AS_DELIVERED_REASON_UNKNOWN"] = "MARK_AS_DELIVERED_REASON_UNKNOWN";
    MarkAsDeliveredReason["RETAILER_MARKED_DELIVERED"] = "RETAILER_MARKED_DELIVERED";
    MarkAsDeliveredReason["ADMIN_FULFILL_REPLACEMENT_ORDER"] = "ADMIN_FULFILL_REPLACEMENT_ORDER";
  })(MarkAsDeliveredReason = IBrandOrder.MarkAsDeliveredReason || (IBrandOrder.MarkAsDeliveredReason = {}));
  var BrandActionDeadlineType;
  (function (BrandActionDeadlineType) {
    BrandActionDeadlineType["BRAND_ACTION_DEADLINE_TYPE_UNKNOWN"] = "BRAND_ACTION_DEADLINE_TYPE_UNKNOWN";
    /**
     * The ActionDeadlineAt represents the deadline for the brand to accept the order
     */
    BrandActionDeadlineType["ORDER_ACCEPT_DEADLINE"] = "ORDER_ACCEPT_DEADLINE";
    /**
     * The ActionDeadlineAt represents the deadline for the brand to ship the order
     */
    BrandActionDeadlineType["SHIP_DEADLINE"] = "SHIP_DEADLINE";
    /**
     * TODO(chinmayanathany): Delete this after the backfill has been run
     */
    BrandActionDeadlineType["ACTION_DEADLINE_TYPE_UNKNOWN"] = "ACTION_DEADLINE_TYPE_UNKNOWN";
    /**
     * The ActionDeadlineAt represents the deadline for the brand to enter the estimated ship date for backorders
     */
    BrandActionDeadlineType["BACKORDER_ENTER_ESTIMATED_SHIP_DATE_DEADLINE"] = "BACKORDER_ENTER_ESTIMATED_SHIP_DATE_DEADLINE";
  })(BrandActionDeadlineType = IBrandOrder.BrandActionDeadlineType || (IBrandOrder.BrandActionDeadlineType = {}));
  /**
   * Return an instance of IBrandOrder with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  IBrandOrder.build = function (partial) {
    return _objectSpread({
      shipments: [],
      pending_shipments: [],
      order_items: [],
      applied_discounts: [],
      issue_reports: [],
      tags: [],
      conversion_rates: [],
      duties_and_taxes_estimates: [],
      chargeable_tax_items: [],
      shipment_items: [],
      markdown_allowances: []
    }, partial !== null && partial !== void 0 ? partial : {});
  };
})(IBrandOrder || (IBrandOrder = {}));